import { For, type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { type CoreRole, type CoreSquad, roleBars } from '../lib/fleet-live-core';
import { count } from '../lib/time';

// One squad's feed body (#6779, prototype `:3497-3499`, `:3828-3838`): "Repos · <name> ·
// <name>" (each name a button that makes it the Merge Gate's subject), the three role bars
// scaled to the squad's agents with a 1.5% floor (none when the read sent no bucket, and no
// "Idle" bar), and "Live in this squad", its 3 newest in-flight items. The list re-derives
// on each stream patch rather than on a 1,500 ms clock (brief.md item 76).

const ROLE_LABEL: Readonly<Record<CoreRole, () => string>> = {
  writing: () => t('fleet.live.role_writing'),
  reviewing: () => t('fleet.live.role_reviewing'),
  fixing: () => t('fleet.live.role_fixing'),
};

export function FleetLiveSquadBody(props: {
  readonly squad: CoreSquad;
  readonly onRepo: (repo: string) => void;
}): JSX.Element {
  return (
    <>
      <p class="fleet-live__sq-repos">
        <span class="fleet-live__sq-label">{t('fleet.live.squad_repos')}</span>
        <For each={props.squad.repos}>
          {(repo) => (
            <>
              <span aria-hidden="true">{t('fleet.live.sep')}</span>
              <button type="button" class="fleet-live__sq-repo" onClick={() => props.onRepo(repo)}>
                {repo}
              </button>
            </>
          )}
        </For>
      </p>
      <Show when={roleBars(props.squad)}>
        {(bars) => (
          <ul class="fleet-live__sq-bars">
            <For each={bars()}>
              {(bar) => (
                <li class={`fleet-live__sq-bar fleet-live__sq-bar--${bar.role}`}>
                  <span>{ROLE_LABEL[bar.role]()}</span>
                  <span class="fleet-live__sq-track" aria-hidden="true">
                    <i
                      class={`fleet-live__sq-fill fleet-live__sq-fill--${bar.role}`}
                      style={{ width: `${bar.pct.toFixed(1)}%` }}
                    />
                  </span>
                  <b>{count(bar.count)}</b>
                </li>
              )}
            </For>
          </ul>
        )}
      </Show>
      <div class="fleet-live__sq-live">
        <h4 class="fleet-live__sq-label">{t('fleet.live.squad_live')}</h4>
        <ul>
          <For
            each={props.squad.live}
            fallback={
              <li>
                <span class="fleet-live__sq-tag" aria-hidden="true">
                  {t('fleet.live.squad_live_none')}
                </span>
                <span class="fleet-live__sq-empty">{t('fleet.live.squad_live_empty')}</span>
              </li>
            }
          >
            {(line) => (
              <li>
                <span class="fleet-live__sq-tag">
                  {line.number === null ? '' : t('fleet.live.item_number', { number: line.number })}
                </span>
                <span>{line.title}</span>
              </li>
            )}
          </For>
        </ul>
      </div>
    </>
  );
}
